import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import "../i18n";

export function HelpPopover({ text }: { text?: string | undefined }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const box = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    const onClick = (e: MouseEvent) => {
      if (!box.current?.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("keydown", onKey);
    document.addEventListener("mousedown", onClick);
    return () => {
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("mousedown", onClick);
    };
  }, [open]);

  if (!text) return null;

  return (
    <div className="helpwrap" ref={box}>
      <button
        className="helpbtn"
        type="button"
        aria-label={t("help.aboutScreen", "About this screen")}
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        ?
      </button>
      {open ? (
        <div className="helppop" role="dialog" aria-label={t("help.aboutScreen", "About this screen")}>
          {text}
        </div>
      ) : null}
    </div>
  );
}
